module.exports = __webpack_public_path__ + "img/sub.d6c21222.webp";